import { render, staticRenderFns } from "./H5TemplateConfig.vue?vue&type=template&id=2780d811&scoped=true&"
import script from "./H5TemplateConfig.vue?vue&type=script&lang=js&"
export * from "./H5TemplateConfig.vue?vue&type=script&lang=js&"
import style0 from "./H5TemplateConfig.vue?vue&type=style&index=0&id=2780d811&prod&lang=css&"
import style1 from "./H5TemplateConfig.vue?vue&type=style&index=1&id=2780d811&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780d811",
  null
  
)

export default component.exports